import $ from "jquery";

class Dropdowns {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		const dropdownElems = self.elem.getElementsByClassName("js-dropdown");

		for (let i = 0; i < dropdownElems.length; i++) {
  			let selElmnt = dropdownElems[i].getElementsByTagName("select")[0];

			/* For each element, create a new DIV that will act as the selected item: */
			let selectedItemDiv = document.createElement("DIV");
			selectedItemDiv.setAttribute("class", "select-selected");
			// selectedItemDiv.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
			selectedItemDiv.innerHTML = selElmnt.getAttribute('data-label');
			dropdownElems[i].appendChild(selectedItemDiv);


  			/* For each element, create a new DIV that will contain the option list: */
  			let optionsListDiv = document.createElement("DIV");
  			optionsListDiv.setAttribute("class", "select-items select-hide");

  			for (let j = 0; j < selElmnt.length; j++) {
			    /* For each option in the original select element,
			    create a new DIV that will act as an option item: */
			    let optionItem = document.createElement("DIV");
			    optionItem.innerHTML = selElmnt.options[j].innerHTML;

			    optionItem.addEventListener("click", function(e) {
			        /* When an item is clicked, update the original select box,
			        and the selected item: */
			        let selectElem = this.parentNode.parentNode.getElementsByTagName("select")[0];
					let sibling = this.parentNode.previousSibling;

			        for (let i = 0; i < selectElem.length; i++) {
			          	if (selectElem.options[i].innerHTML == this.innerHTML) {
				            selectElem.selectedIndex = i;
				            sibling.innerHTML = this.innerHTML;
				            let lastSelectedItems = this.parentNode.getElementsByClassName("same-as-selected");
				            for (let k = 0; k < lastSelectedItems.length; k++) {
				              lastSelectedItems[k].removeAttribute("class");
				            }
							this.setAttribute("class", "same-as-selected");
							
							if ("createEvent" in document) {
								var evt = document.createEvent("HTMLEvents");
								evt.initEvent("change", false, true);
								selectElem.dispatchEvent(evt);
							} else {
								selectElem.fireEvent("onchange");
							}
							
				            break;
			        	}
        			}
        			sibling.click();
    			});

    			optionsListDiv.appendChild(optionItem);
  			}

  			dropdownElems[i].appendChild(optionsListDiv);
  			selectedItemDiv.addEventListener("click", function(e) {
			    /* When the select box is clicked, close any other select boxes,
			    and open/close the current select box: */
			    e.stopPropagation();
			    self.closeAllSelect(this);
			    this.nextSibling.classList.toggle("select-hide");
			    this.classList.toggle("select-arrow-active");
  			});
		}


		/* If the user clicks anywhere outside the select box,
		then close all select boxes: */
		document.addEventListener("click", self.closeAllSelect);
	}

	closeAllSelect(el) {
  		/* A function that will close all select boxes in the document,
  		except the current select box: */
  		let arrNo = [];
  		let selectItemElems = document.getElementsByClassName("select-items");
		
  		let selectedItems = document.getElementsByClassName("select-selected");

  		for (let i = 0; i < selectedItems.length; i++) {
    		if (el == selectedItems[i]) {
      			arrNo.push(i)
    		} else {
      			selectedItems[i].classList.remove("select-arrow-active");
    		}
  		}

  		for (let i = 0; i < selectItemElems.length; i++) {
    		if (arrNo.indexOf(i)) {
      			selectItemElems[i].classList.add("select-hide");
    		}
  		}
	}
}

export default Dropdowns;